module.exports = __webpack_public_path__ + "img/Wales.ef9d1ff2.svg";